import { createFileRoute, redirect } from "@tanstack/react-router";
import { FeatureDisabledPage } from "@/features/features";
import { CANONICAL_FEATURES, type FeatureCode } from "@/features/system-admin/constants/features";

const featureCodes = new Set<string>(CANONICAL_FEATURES.map((f) => f.code));

export const Route = createFileRoute("/_admin/feature-disabled/$code")({
  beforeLoad: ({ params }) => {
    if (!featureCodes.has(params.code)) {
      throw redirect({ to: "/", replace: true });
    }
  },
  component: FeatureDisabledRoute,
});

function FeatureDisabledRoute() {
  const { code } = Route.useParams();
  return <FeatureDisabledPage feature={code as FeatureCode} />;
}
